import "./ButtonToTop.scss";
import UpArrow from "../UpArrow/UpArrow";
import { motion, AnimatePresence } from "framer-motion";
import buttonToTopVariants from "../../../Services/variants/buttonToTopVariants";

const ButtonToTop = ({ appearTopButton }) => {
	const scrollToTopHandler = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};

	return (
		<AnimatePresence>
			{appearTopButton && (
				<motion.div
					variants={buttonToTopVariants}
					initial="hidden"
					animate="visible"
					exit="exit"
				>
					<button className="buttonToTop--button" onClick={scrollToTopHandler}>
						<UpArrow />
					</button>
				</motion.div>
			)}
		</AnimatePresence>
	);
};

export default ButtonToTop;
